import React from 'react';
import Link from 'next/link';

import { Lock1, Unlock } from 'iconsax-react';

import { hexToRgba } from 'utils/colorUtils';

import classes from './ToolkitCard.module.scss';

const ToolkitCard = ({ toolkit }) => {
    const categoryColor = toolkit?.category?.color || '#BB3A90';

    return (
        <Link href={`/toolkits/${toolkit.id}/${toolkit.slug}`} className={classes['card']}>
            <div className={classes['header']}>
                <span
                    className={classes['type-badge']}
                    style={{
                        backgroundColor: hexToRgba(categoryColor, 0.12),
                        color: categoryColor,
                    }}
                >
                    {toolkit?.category?.name}
                </span>
                {toolkit?.category?.logo && (
                    <span
                        className={classes['type-icon']}
                        style={{ backgroundColor: hexToRgba(categoryColor, 0.12) }}
                    >
                        <img src={toolkit.category.logo} alt={toolkit?.category?.name || ''} />
                    </span>
                )}
            </div>
            <div className={classes['body']}>
                <h3>{toolkit?.name}</h3>
                <p>{toolkit?.description}</p>
            </div>
            <div className={classes['footer']}>
                {toolkit?.has_access ? (
                    <span className={`${classes['access']} ${classes['unlocked']}`}>
                        <Unlock size={14} />
                        Unlocked
                    </span>
                ) : (
                    <span className={`${classes['access']} ${classes['locked']}`}>
                        <Lock1 size={14} />
                        Locked
                    </span>
                )}
            </div>
        </Link>
    );
};

export default ToolkitCard;
